import {
  useState,
  useEffect,
  useContext,
  JSXElementConstructor,
  Key,
  ReactElement,
  ReactNode,
  ReactPortal,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getDynamicFormTabs } from "../../Helpers/APIEndpoints/Endpoints";
import { LoaderContext } from "../../Helpers/Context/Context";
import { Collapse, Form, Tabs } from "antd";
import "../../Components/DynamicForm/DynamicForm.css";
import DynamicFormComponent from "../../Components/DynamicForm/DynamicForm";
import { API } from "../../Axios/Axios";
import DynamicReport from "../../Components/DynamicReport/DynamicReport";

const { TabPane } = Tabs;
const InterfaceComponent = (props: any) => {
  const location = useLocation();
  const { state } = location || {};
  const [formData, setFormData] = useState<any>(null);
  const [activeTab, setActiveTab] = useState<any>(null);
  const [form] = Form.useForm();
  const [actionType, setActionType] = useState(
    state?.actionType || props?.actionType
  );
  const [activeTabId, setActiveTabId] = useState<any>(null);
  const [RId, setRId] = useState(state?.RId || props?.RId);
  const [interfaceId, setInterfaceId] = useState<Number>(
    state?.id || props?.id || 0
  );
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [gridData, setGridData] = useState<Record<string, any>>([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!state?.id) {
      return;
    }
    setInterfaceId(state?.id);
  }, [state]);

  useEffect(() => {
    setFormData([]);
    if (interfaceId) getFormTabsConfig();
  }, [interfaceId]);

  // Get config from backend
  const getFormTabsConfig = async () => {
    try {
      showLoader();

      let formTabs = await API.post(getDynamicFormTabs, {
        InterfaceId: interfaceId,
      });

      let dynamicFormData;
      let tempDefaultActiveTab = 0;
      if (formTabs && formTabs.data?.data?.length > 0) {
        dynamicFormData = formTabs.data;
        var defaultActiveTab = formTabs.data.data.find(
          (x: { AdditionalDetails: { IsDefault: boolean } }) =>
            x.AdditionalDetails?.IsDefault === true
        );

        tempDefaultActiveTab = defaultActiveTab
          ? defaultActiveTab?.TabId.toString()
          : formTabs.data.data[0]?.TabId.toString();
        var defaultActiveTabIndex = defaultActiveTab
          ? formTabs.data.data.findIndex(
              (x: { TabId: number }) =>
                x.TabId.toString() === tempDefaultActiveTab.toString()
            )
          : 0;

        setActiveTabId(tempDefaultActiveTab);
        setActiveTab(defaultActiveTabIndex.toString());
      } else {
        dynamicFormData = null;
        setActiveTabId(0);
        setActiveTab(null);
      }

      setFormData(dynamicFormData);
    } catch (error) {
      hideLoader();
      console.warn(error);
    } finally {
      hideLoader();
    }
  };

  const getKeyLength = (obj?: any, targetKey?: string): number | 0 => {
    if (!obj || typeof obj !== "object") return 0;

    if (targetKey) {
      if (targetKey in obj) {
        const value = obj[targetKey];

        if (typeof value === "string") return value.length;
        if (Array.isArray(value)) return value.length;
        if (typeof value === "object") return Object.keys(value).length;
      }

      for (const value of Object.values(obj)) {
        const length = getKeyLength(value, targetKey);
        if (length !== null) return length;
      }
    }

    return 0;
  };

  const handleTabChange = async (key: any) => {
    setActiveTabId(formData.data[parseInt(key)].TabId);
    setActiveTab(key.toString());
  };

  const validateMessages = {
    required: "${label} is required",
  };

  return (
    <div className="container-fluid">
      {/* <div className="col-lg-12 "> 
        <div className="pageName">
        <Title level={4}> 
          {formData && formData.data && formData.data[0]?.section?.length > 0 ? formData.data[0]?.section[0]?.interfaceName : "" }
          
         </Title>
        </div> 
       </div> */}
      <div className="row">
        <div className="col-lg-12 ">
          <div className="form-container m-0">
            {" "}
            <Form
              form={form}
              layout="vertical"
              validateMessages={validateMessages}
            >
              {formData?.data?.some(
                (tab: { [x: string]: any; TabName: any }) =>
                  tab.TabId && tab.TabId.toString() != "0"
              ) ? (
                <>
                  <Tabs activeKey={activeTab} onChange={handleTabChange}>
                    {formData.data.map(
                      (
                        tab: {
                          AdditionalDetails: any;
                          TabId: Key | null | undefined;
                          TabName:
                            | string
                            | number
                            | boolean
                            | ReactElement<
                                any,
                                string | JSXElementConstructor<any>
                              >
                            | Iterable<ReactNode>
                            | ReactPortal
                            | null
                            | undefined;
                          section: any[];
                        },
                        index: { toString: () => Key | null | undefined }
                      ) => (
                        <TabPane tab={tab.TabName} key={index.toString()}>
                          {tab?.AdditionalDetails?.ContentType ===
                          "dashboard" ? (
                            <>
                              <DynamicReport
                                id={3}
                                dashboardId={1}
                                props={undefined}
                              ></DynamicReport>
                            </>
                          ) : (
                            <>
                              <DynamicFormComponent
                                activeTab={activeTabId}
                                form={form}
                                id={interfaceId}
                                actionType={actionType}
                                RId={RId}
                                handleCancel={props?.handleCancel}
                                Mode={props?.Mode}
                              ></DynamicFormComponent>
                            </>
                          )}
                        </TabPane>
                      )
                    )}
                  </Tabs>
                </>
              ) : (
                <>
                  <DynamicFormComponent
                    id={interfaceId}
                    activeTab={null}
                    form={form}
                    actionType={actionType}
                    RId={RId}
                    handleCancel={props?.handleCancel}
                    Mode={props?.Mode}
                  ></DynamicFormComponent>
                </>
              )}
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterfaceComponent;
